import { Skeleton } from '@olxeu-jobs/ui';
import type { CompanyProfileIndustry } from '~api';
import { LoaderWrapper } from './styled-components';
import type { EmployerCardLoaderProps } from './types';
import { EmployerCard } from './employer-card';

export const EmployerCardLoader = ({ compact }: EmployerCardLoaderProps) => (
  <LoaderWrapper aria-hidden="true">
    <EmployerCard
      compact={compact}
      headingLevel={2}
      publicPath=""
      profile={{
        companyName: '\u00A0', // non-breaking space
        logoUrl: null,
        industry: '' as CompanyProfileIndustry,
        bannerUrl: null,
        counters: {
          ads: 0,
          cities: 0,
        },
      }}
    />
    <Skeleton
      variant="image"
      width="100%"
      height="100%"
      $style={{ position: 'absolute', left: 0, top: 0 }}
    />
  </LoaderWrapper>
);
